import { createFileRoute } from '@tanstack/react-router';
import BillingTab from '../../../../../../components/account-management/settings/billing-tab/BillingTab';
import Loader from '../../../../../../components/shared/custom-components/Loader';

export const Route = createFileRoute(
  '/_authenticated/client/$accountId/_clientWrapper/settings/billing',
)({
  pendingComponent: () => (
    <Loader marginTop={3} fillSpace LoaderContainerClasses={{}} />
  ),
  component: BillingTab,
});
